import { Hand, PenLine, Pencil, Sparkles } from 'lucide-react';
import { useState } from 'react';
import { useT, type MessageKey } from '../../i18n';
import { FINGER_DRAW_PREFS, readFingerDraw, writeFingerDraw, type FingerDrawPref } from './fingerDraw';
import { OptionCard, SettingsSection } from './parts';

const META: Record<FingerDrawPref, { title: MessageKey; desc: MessageKey; icon: typeof Hand }> = {
  auto: { title: 'settings.draw_auto', desc: 'settings.draw_auto_desc', icon: Sparkles },
  finger: { title: 'settings.draw_finger', desc: 'settings.draw_finger_desc', icon: Hand },
  pen: { title: 'settings.draw_pen', desc: 'settings.draw_pen_desc', icon: Pencil },
};

export function DrawingSection() {
  const t = useT();
  const [pref, setPref] = useState<FingerDrawPref>(readFingerDraw);
  const choose = (v: FingerDrawPref) => {
    setPref(v);
    writeFingerDraw(v);
  };
  return (
    <SettingsSection icon={PenLine} title={t('settings.drawing')} id="settings-drawing">
      <div role="radiogroup" aria-label={t('settings.drawing')} className="flex flex-col gap-3 p-5">
        {FINGER_DRAW_PREFS.map((v) => (
          <OptionCard key={v} selected={pref === v} onSelect={() => choose(v)} icon={META[v].icon} title={t(META[v].title)} desc={t(META[v].desc)} />
        ))}
        <p className="px-1 text-[14px] text-[var(--muted)]">{t('settings.draw_hint')}</p>
      </div>
    </SettingsSection>
  );
}
